import React, { Component } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Radio, Tooltip } from 'hljd'
import styles from '../style.module.less'
import { observer, inject } from 'mobx-react'
import { plusMinus } from '@util'
import { getObjValue } from '@hlj/hlj-utils'
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
@inject('store')
@observer
export default class extends Component {
  render() {
    const {
      overview,
      overviewTab,
      changValue,
      tabArray,
      tab
    } = this.props.store

    const timeArray = [['昨', '近7', '近30', '近60'], ['一', '7', '30', '60']]

    return (
      <div className={styles.block}>
        <p className={styles.title}>{tabArray[tab]}数据概览</p>

        <RadioGroup value={overviewTab} onChange={changValue('overviewTab')}>
          <RadioButton value="0">昨日</RadioButton>
          <RadioButton value="1">近7日</RadioButton>
          <RadioButton value="2">近30日</RadioButton>
          <RadioButton value="3">近60日</RadioButton>
        </RadioGroup>

        <div className={styles.box}>
          <div className={styles.label}>
            <p>
              {timeArray[0][overviewTab]}日环比<Tooltip
                placement="top"
                title={`指${timeArray[0][overviewTab]}日相比之前${
                  timeArray[1][overviewTab]
                }日的数值作比较，发生变化的百分比`}
              >
                <QuestionCircleOutlined />
              </Tooltip>
            </p>

            <p>
              行业排名<Tooltip
                placement="top"
                title={
                  '在一定时间范围内的某个上述指标，在同城市同品类商家中的排名。注意：除了跳失率，其他指标越大越好'
                }
              >
                <QuestionCircleOutlined />
              </Tooltip>
            </p>
          </div>
          <div className={styles.data}>
            <ul>
              <li>
                曝光量<Tooltip
                  placement="top"
                  title={`在时间范围内，当前店铺${tabArray[tab]}的总曝光次数`}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                访问量<Tooltip
                  placement="top"
                  title={`在时间范围内，当前店铺${
                    tabArray[tab]
                  }的总访问(点击)次数`}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                CTR<Tooltip
                  placement="top"
                  title={`在时间范围内，当前店铺${
                    tabArray[tab]
                  }的总访问(点击)次数 / 总曝光次数`}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                平均停留时长(s)<Tooltip
                  placement="top"
                  title={`在时间范围内，在${tabArray[tab]}详情页平均停留时长`}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
              <li>
                {tabArray[tab]}质量分<Tooltip
                  placement="top"
                  title={`一定时间范围内，所有上架${
                    tabArray[tab]
                  }的平均质量分数。根据CTR、停留时长等指标综合推算`}
                >
                  <QuestionCircleOutlined />
                </Tooltip>
              </li>
            </ul>

            <ul className={styles.num}>
              <li>{getObjValue(overview, 'expo_num.data') || 0}</li>
              <li>{getObjValue(overview, 'visit_num.data') || 0}</li>
              <li>{getObjValue(overview, 'ctr.data') || 0}</li>
              <li>{getObjValue(overview, 'duration.data') || 0}</li>
              <li>{getObjValue(overview, 'score.data') || 0}</li>
            </ul>

            <ul className={styles.compare}>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'expo_num.compare'))
                }}
              >
                {getObjValue(overview, 'expo_num.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'visit_num.compare'))
                }}
              >
                {getObjValue(overview, 'visit_num.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'ctr.compare'))
                }}
              >
                {getObjValue(overview, 'ctr.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'duration.compare'))
                }}
              >
                {getObjValue(overview, 'duration.compare') || 0}
              </li>
              <li
                style={{
                  color: plusMinus(getObjValue(overview, 'score.compare'))
                }}
              >
                {getObjValue(overview, 'score.compare') || 0}
              </li>
            </ul>

            <ul className={styles.ranking}>
              <li>{getObjValue(overview, 'expo_num.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'visit_num.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'ctr.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'duration.ranking') || '-'}</li>
              <li>{getObjValue(overview, 'score.ranking') || '-'}</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}
